import IconBase from "./IconBase";

// A typographic T — the field holds plain text.
const TextIcon = (props) => (
    <IconBase {...props}>
        <path d="M5 6.5h14" />
        <path d="M12 6.5v11" />
        <path d="M9.25 17.5h5.5" />
    </IconBase>
);

export default TextIcon;
